function* idGenerator(prefix = ''): IterableIterator<string> {
  let i = 0
  while (true) {
    yield prefix + i++
  }
}

export default idGenerator
